import { createFileRoute } from '@tanstack/react-router';
import { TransferSettingsPage } from '@/features/transfer-settings/transfer-settings-page.js';

export const Route = createFileRoute('/_app/settings/transfers')({
  component: TransferSettingsPage,
});
